import { nextTick, onUpdated } from 'vue';

export default {
  mounted(el, binding) {
    const selector = binding.value || '> *'; // Default to direct children if no selector is provided

    const equalizeHeights = async () => {
      await nextTick(); 

      const children = Array.from(el.querySelectorAll(selector));
      children.forEach(child => {
        child.style.height = 'auto';
      });

      const maxHeight = children.reduce((max, child) => {
        return Math.max(max, child.offsetHeight);
      }, 0);

      if (maxHeight > 0) {
        children.forEach(child => {
          child.style.height = `${maxHeight}px`;
        });
      }
    };

    equalizeHeights();
    window.addEventListener('resize', equalizeHeights);

    el.__cleanup__ = () => {
      window.removeEventListener('resize', equalizeHeights);
    };
  },
  updated(el,binding){
    const selector = binding.value || '> *'; 

    const equalizeHeights = async () => {
      await nextTick(); 

      const children = Array.from(el.querySelectorAll(selector));

      children.forEach(child => {
        child.style.height = 'auto';
      });

      const maxHeight = children.reduce((max, child) => {
        return Math.max(max, child.offsetHeight);
      }, 0);

      if (maxHeight > 0) {
        children.forEach(child => {
          child.style.height = `${maxHeight}px`;
        });
      }
    };

    // Call once and whenever window resizes
    equalizeHeights();
  },
  unmounted(el) {
    if (el.__cleanup__) {
      el.__cleanup__();
    }
  }
};
